import React from 'react'
import VehicleNote from '../2_Confirm/VehicleNote/VehicleNote'
import VehicleConfirm_Main from '../2_Confirm/ConfirmBody/VehicleConfirm_Main'
import { NewDelete_VehicleContext, NewDelete_VehicleContextComp } from '../ReplaceVehicleContext/NewDelete_VehicleContext'
import { ReplaceVehicleContext } from '../ReplaceVehicleContext/ReplaceVehicleContext'
import ReplaceVehicleBtnNav from '../1_Vehicle/ReplaceVehicleBtnNav/ReplaceVehicleBtnNav'


const ConfirmReplaceVehicleMain = () => {
    return (
        <>
            <NewDelete_VehicleContextComp>
                <span className='px-md-5'>
                    <VehicleConfirm_Main requestContext={ReplaceVehicleContext} vehicleContext={NewDelete_VehicleContext} reqClass={"replaceVehicleClass"} endorsementType={"Replace Vehicle"} /> 
                </span>
                <hr />
                <VehicleNote />
                <hr />
                <ReplaceVehicleBtnNav />
            </NewDelete_VehicleContextComp>
        </>
    )
}

export default ConfirmReplaceVehicleMain